import { usePipelineStages, PipelineStage } from '@/hooks/usePipelineStages';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface SelectPipelineStageProps {
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
}

export function SelectPipelineStage({
  value,
  onValueChange,
  placeholder = 'Select stage',
}: SelectPipelineStageProps) {
  const { stages, isLoading } = usePipelineStages();

  if (isLoading) {
    return (
      <Select disabled>
        <SelectTrigger>
          <SelectValue placeholder="Loading stages..." />
        </SelectTrigger>
      </Select>
    );
  }

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {stages?.map((stage: PipelineStage) => (
          <SelectItem
            key={stage.id}
            value={stage.id.toString()}
            style={{
              // Add a small color indicator
              borderLeftWidth: '4px',
              borderLeftStyle: 'solid',
              borderLeftColor: stage.color,
              paddingLeft: '12px',
            }}
          >
            {stage.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
